import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FlexContainer,
  ScrollableContainer,
  Page,
  AnimatedList,
} from "../../components/styled";
import { useLoading } from "../../context/LoadingContext";
import PendingIcon from "../../assets/images/pending.png";
import TickImage from "../../assets/icons/tick.png";
import CloseImage from "../../assets/icons/close.png";
import NovaImage from "../../assets/images/logo/tokens/nova.png";
import USD1Image from "../../assets/images/logo/tokens/usd1.png";
import NoDataImage from "../../assets/images/noData.png";
import { getOrders } from "../../service/main/api";
import CustomSelect from "../../components/shared/customSelect";
// import { useNavigate } from "react-router-dom";
import { scaleInCenter,hearthbeat } from "../../components/styled/animations";
import { formatEthers, shortenedTxHash } from "../../utils";
import ArrowDown from "../../assets/icons/arrowDown.svg";

const OrderItem = ({ order }) => {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <FlexContainer flexdirection="column">
      <TransactionItemContainer>
        <LeftContainer>
          {/* <StyledImage src={order.image} alt="pack"/> */}
          <FlexContainer flexdirection="column">
            <StyledText>
              Payment:
              <img style={{ width: "18px" }} src={NovaImage} alt="nova" />{" "}
              <strong>{formatEthers(order.tokenAmount)} Nova</strong>{" "}
            </StyledText>
            <StyledText>
              Payment:
              <img style={{ width: "18px" }} src={USD1Image} alt="usd1" />{" "}
              <strong>{formatEthers(order.totalUsdPrice)} USD1</strong>{" "}
            </StyledText>
            <StyledText>
              TxHash: <strong>{shortenedTxHash(order.txHash)}</strong>
            </StyledText>
          </FlexContainer>
        </LeftContainer>
        <StatusContainer>

          <img
            src={
              order.status === "pending"
                ? PendingIcon
                : order.status === "completed"
                  ? TickImage
                  : CloseImage
            }
            alt="status"
          />
          <span>{order.status}</span>
                    <DetailsIcon
                     style={{width: 15,height:15}}
                    onClick={()=> setShowDetails((prev) => !prev)}
                    src={ArrowDown} alt="status"/>
        </StatusContainer>
      </TransactionItemContainer>
      <DetailsContainer visible={showDetails}>
       { order.items.map((item,i) => (
          <DetailsItem key={i}>
            <FlexContainer style={{gap:"4px", alignItems:"center",width:"fit-content"}}>
           <StyledImage src={item.productImage} alt={item.productName} /> <span>{item.productName}</span>
            </FlexContainer>
            <span>{item.quantity}</span>
          </DetailsItem>
        ))}
        </DetailsContainer>
    </FlexContainer>
  );
};

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [processedOrders,setProcessedOrders] = useState([])
  const { setIsLoading } = useLoading();
  const [showUnprocessed, setShowUnprocessed] = useState(false);

  useEffect(() => {
    const fetchOrders = async () => {
      setIsLoading(true);
      try {
        const res = await getOrders();
        setOrders(res.data);
        setProcessedOrders(res.data.filter(order => order.status !== "unprocessed"));
      } catch (error) {
        console.error("Failed to fetch orders:", error);
      }
      setIsLoading(false);
    };
    fetchOrders();
  }, []);
  const refreshOrders = async () => {
    setIsLoading(true);
    try {
      const res = await getOrders();
      setOrders(res.data);
      setProcessedOrders(res.data.filter(order => order.status !== "unprocessed"));
    } catch (error) {
      console.error("Failed to fetch orders:", error);
    }
    setIsLoading(false);
  };
  return (
    <Page>
      <FilterTab>
        <CustomSelect
          options={[
            { label: "Hide Unprocessed", value: false },
            { label: "Show All", value: true },
          ]}
          value={showUnprocessed}
          onChange={(value) => setShowUnprocessed(value)}
        /> 
            <RefreshButton onClick={refreshOrders}>Refresh</RefreshButton>
      </FilterTab> 
      <ScrollableContainer>
        {orders?.length > 0 ? (
          <TransactionList>
            {showUnprocessed? 
            React.Children.toArray(
                orders.map((t, i) => (
                <AnimatedList
                  style={{ animationDelay: `${i * 0.18}s`, width: "100%" }}
                >
                  <OrderItem order={t} />
                </AnimatedList>
              )),
            )
            :
            React.Children.toArray(
                processedOrders.map((t, i) => (
                <AnimatedList
                  style={{ animationDelay: `${i * 0.18}s`, width: "100%" }}
                >
                  <OrderItem order={t} />
                </AnimatedList>
              )),
            )
            }
          </TransactionList>
        ) : (
          <FlexContainer
            style={{
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img src={NoDataImage} alt="no data" />
          </FlexContainer>
        )}
      </ScrollableContainer>
    </Page>
  );
};

export default Orders;

const FilterTab = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 12px;
  background-color: rgba(65, 65, 66, 0.18);
  backdrop-filter: blur(52.70000076293945px);
  -webkit-backdrop-filter: blur(52.70000076293945px);
  height: 48px;
  width: 100%;
  border-radius: 12px;
  margin-bottom: 8px;
  /* position: absolute; */
  top: 8px;
  z-index: 1;
`;
const TransactionList = styled(FlexContainer)`
  gap: 8px;
  flex-direction: column;
  padding: 8px;
`;
const TransactionItemContainer = styled(FlexContainer)`
  height: 84px;
  border: 1px solid #7455bf;
  backdrop-filter: blur(52.70000076293945px);
  -webkit-backdrop-filter: blur(52.70000076293945px);
  border-radius: 18px;
  padding: 0 16px;
  justify-content: space-between;
  gap: 8px;
`;
const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  width: 64px;
  img {
    width: 24px;
    height: 24px;
  }
  span {
    font-size: 0.8em;
    color: #ffffff;
    opacity: 0.7;
    text-transform: uppercase;
  }
`;
const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  ${FlexContainer} {
    justify-content: flex-start;
    align-items: flex-start;
    gap: 4px;
  }
`;
const StyledImage = styled.img`
  width: auto;
  max-width: 42px;
  height: 80%;
  animation: ${scaleInCenter} 0.5s ease-in-out forwards;
`;
const StyledText = styled.span`
  color: #fffafac2;
  font-size: 10px;
  font-weight: 400;
  /* opacity:0.7; */
  display: flex;
  align-items: center;
  gap: 4px;
`;

const DetailsContainer = styled.div`
    align-items:flex-start;
    gap:8px;
    width: 100%;
    height: 120px;
    display: ${({visible}) => visible ? "flex" : "none"};
    padding:8px 16px;
    overflow-y: auto;
`;

const DetailsItem = styled(FlexContainer)`
    justify-content:space-between;
    align-items:center;
    width:100%;
    border-bottom:1px solid #7455bf;
    span{
        font-size: 10px;
        color: #ffffff;
    }
`;
const DetailsIcon = styled.img`
    animation: ${hearthbeat} 2s infinite both;
    cursor: pointer;
`;

const RefreshButton = styled.button`
    padding: 8px 16px;
    border-radius: 8px;
    background-color: #7455bf;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    
`;